export const environment = {
    production: true,
    api: 'https://dev.api.classichub.co.nz',
    buildVersion: '2026.9.17.3',
    uri: 'https://dev.classichub.co.nz',
    envName: 'dev',
    isTest: true,
};

